import { z } from 'zod/v4';

const Numeric = z.union([z.number(), z.null(), z.literal(NaN), z.literal(Infinity), z.literal(-Infinity)]);

/**
 * Dense numeric time-series representation.
 * Values and issues are index-aligned JSON-native arrays. Index zero corresponds
 * to startDate; each next index is intervalDays later. Nonfinite values remain
 * supported by the canonical transport; individual metrics may restrict them.
 * This leaf module keeps browser-only consumers independent of the API barrel.
 */
export const TimeSeriesV2Runtype = z.object({
    /** Optional stable key for deduplicating/reusing this exact computed series. */
    idempotencyKey: z.string().optional(),
    /** ISO date for the first point in values and issues. */
    startDate: z.iso.date(),
    /** Distance in days between adjacent points. For weekly series, this is 7. */
    intervalDays: z.number().int().positive(),
    /** Authoritative numeric metric values; null marks a missing point. */
    values: z.array(Numeric),
    /** Diagnostic bit masks aligned by index with values. */
    issues: z.array(z.number().int()),
});
export type TimeSeriesV2 = z.infer<typeof TimeSeriesV2Runtype>;
